import store from '../redux/store/store';

const getSelectedDateKey = () => {
	const { selectedDates } = store.getState().dashboard;
	let key = '';
	for(let selectedDateKey in selectedDates) {
		if(!selectedDates.hasOwnProperty(selectedDateKey)) {
			continue;
		}
		const date = selectedDates[selectedDateKey];
		key += `${date.year()}${date.month()}`;
	}
	return key;
};
export default getSelectedDateKey;
